




















import Vue, { PropOptions } from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { NOC } from '@/class';
import { ISelectOption as iso } from '@/class/models/typed/wild';
import { strFuzzyMatch } from '@/class/common/util';
import ClickOutside from 'vue-click-outside';
export type IOption = iso;

interface Data {
  selectValue: string;
  selectorshow: boolean;
}
interface Methods {
  closeSelect: () => void;
}
interface Computed {
  SELECTED_TEXT: string;
}
interface Props {
  initialValue: string;
  options: iso[];
  disabled: boolean;
}

export default Vue.extend({
  name: 'SelectBox',
  props: {
    initialValue: {
      type: String,
      default: '0',
    },
    options: Array as PropOptions<iso[]>,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectValue: String(NOC.SELECT.NOSELECT.value),
      selectorshow: false,
      searchWord: '',
    };
  },
  computed: {
    SELECTED_TEXT() {
      const opt = this.options.find((option) => this.selectValue === String(option.value));
      if (opt) {
        return opt.text;
      } else {
        if (this.options.length && this.options[0].value === NOC.SELECT.NOSELECT.value) {
          return this.options[0].text; // "未選択" or "選択してください"
        } else {
          return NOC.SELECT.NOSELECT.text; // "未選択"
        }
      }
    },
    OPTIONS() {
      const returnOptions = this.$data.searchWord
        ? this.options.filter((v) => strFuzzyMatch(this.$data.searchWord, v.text))
        : this.options;
      if (returnOptions.length <= 0) {
        returnOptions.push(this.options[0]);
      }

      return returnOptions;
    },
  },
  mounted() {
    let value = this.initialValue;
    // 初期値がない場合、「未選択」を選択
    if (value === String(NOC.SELECT.NOSELECT.value) && this.options.length >= 0) {
      value = String(this.options[0].value);
    }
    this.selectValue = value;
  },
  directives: {
      ClickOutside,
  },
  watch: {
    selectValue() {
      this.$emit('change', this.selectValue);
    },
    initialValue() {
      this.selectValue = this.initialValue;
    },
  },
  methods: {
    onShowList() {
      this.selectorshow = true;
      this.$emit('openclose', this.selectorshow);
    },
    closeSelect() {
      if (this.selectorshow) {
        this.selectorshow = false;
        this.$data.searchWord = '';
        this.$emit('openclose', this.selectorshow);
      }
    },
    eventValue(data: string) {
      this.$data.searchWord = data;
    },
    onClickSelect(option: iso) {
      this.selectValue = option.value.toString();
      this.selectorshow = false;
      this.$data.searchWord = '';
      this.$emit('openclose', this.selectorshow);
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
